/* eslint-disable @typescript-eslint/no-explicit-any */
export const LOCALSTORAGE_KEYS = {
  SHOW_PLAN: 'showplan',
  BROKER_ID: 'brokerId',
  BI: 'BI',
};

export const setITRLocalStorage = (link: string | undefined): void => {
  if (!link) return;
  const url = new URL(link);
  const hasShowPlan = url?.searchParams.has(LOCALSTORAGE_KEYS.SHOW_PLAN);
  const hasBI = url?.searchParams.has(LOCALSTORAGE_KEYS.BI);

  resetITRLocalStorage();

  if (hasShowPlan)
    localStorage.setItem(
      LOCALSTORAGE_KEYS.SHOW_PLAN,
      url.searchParams.get(LOCALSTORAGE_KEYS.SHOW_PLAN)?.toString() as string
    );

  if (hasBI)
    localStorage.setItem(
      LOCALSTORAGE_KEYS.BROKER_ID,
      url.searchParams.get(LOCALSTORAGE_KEYS.BI)?.toString() as string
    );
};

export const resetITRLocalStorage = (): void => {
  localStorage.removeItem(LOCALSTORAGE_KEYS.SHOW_PLAN);
  localStorage.removeItem(LOCALSTORAGE_KEYS.BROKER_ID);
};

export const getCryptoData = (
  data: Array<any>,
  searchKey: string,
  exchangeFilter: string
): any[] => {
  return data.filter((ele) => {
    const { name, type } = ele.brokerDetails;
    const searchName = name.toLowerCase();
    return (
      (searchKey === '' || searchName.includes(searchKey.toLowerCase())) &&
      (exchangeFilter === 'all' ||
        exchangeFilter === 'crypto' ||
        exchangeFilter.toLowerCase() === type.toLowerCase())
    );
  });
};

export const getStocksData = (
  data: Array<any>,
  searchKey: string,
  exchangeFilter: string
): any[] => {
  return data.filter((ele) => {
    const { name, type } = ele.brokerDetails;
    const searchName = name.toLowerCase();
    return (
      (searchKey === '' || searchName.includes(searchKey.toLowerCase())) &&
      (exchangeFilter === 'all' ||
        exchangeFilter.toLowerCase() === type.toLowerCase())
    );
  });
};
